import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["rows", "template"]

  connect() {
    const indices = Array.from(this.rowsTarget.querySelectorAll("input[name]"), (input) =>
      Number(input.name.match(/\[occurrences\]\[(\d+)\]/)[1]))
    this.nextIndex = Math.max(-1, ...indices) + 1
  }

  add() {
    this.rowsTarget.insertAdjacentHTML("beforeend", this.templateTarget.innerHTML.replaceAll("NEW_INDEX", this.nextIndex++))
    this.rowsTarget.lastElementChild.querySelector("input").focus()
  }

  remove(event) {
    event.target.closest("[data-festival-schedule-row]").remove()
  }
}
